import { Skeleton } from "../../../../components";

export interface InputSkeletonProps {}

export function InputSkeleton(props: InputSkeletonProps) {
  return <Skeleton variant="rectangular" height={73} width="100%" />;
}
